import { queryOptions } from '@tanstack/react-query';
import type { AuditLogItem, ListAuditQuery, Paginated } from '@news-cms/shared';
import { api } from './api';

function qs(filter: Partial<ListAuditQuery>): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filter)) {
    if (v === undefined || v === null || v === '') continue;
    params.set(k, String(v));
  }
  return params.toString();
}

export const auditListQueryOptions = (filter: Partial<ListAuditQuery>) =>
  queryOptions({
    queryKey: ['audit', 'list', filter] as const,
    queryFn: () => api<Paginated<AuditLogItem>>(`/api/admin/audit-logs?${qs(filter)}`),
  });

export interface AuditStats {
  totalEvents: number;
  distinctIpCount: number;
  since: string;
}

/** Rolling-window counters for the dashboard security card. Default
 *  window is "last 24h"; pass `sinceMs` to override. */
export const auditStatsQueryOptions = (sinceMs?: number) =>
  queryOptions({
    queryKey: ['audit', 'stats', sinceMs ?? '24h'] as const,
    queryFn: () => {
      const params = sinceMs
        ? `?since=${encodeURIComponent(new Date(Date.now() - sinceMs).toISOString())}`
        : '';
      return api<AuditStats>(`/api/admin/audit-logs/_stats${params}`);
    },
    // Counts move slowly; 60s window keeps the card cheap.
    staleTime: 60_000,
  });

export interface AuditTopAction {
  action: string;
  count: number;
}

export interface AuditTopActionsResponse {
  items: AuditTopAction[];
  since: string;
}

/** Top-N action codes in a sliding window. Backs the dashboard
 *  "ที่เกิดบ่อย" card so unusual bursts pop out without scrolling
 *  the full audit list. */
export const auditTopActionsQueryOptions = (sinceMs?: number) =>
  queryOptions({
    queryKey: ['audit', 'top-actions', sinceMs ?? '24h'] as const,
    queryFn: () => {
      const params = sinceMs
        ? `?since=${encodeURIComponent(new Date(Date.now() - sinceMs).toISOString())}`
        : '';
      return api<AuditTopActionsResponse>(`/api/admin/audit-logs/_top-actions${params}`);
    },
    staleTime: 60_000,
  });
